export default __webpack_public_path__ + "static/media/1111.fd1bcfc2.png";